import React from 'react';

import { useWorkJourneyContext } from '../../../contexts';
import JourneyForm from './JourneyTypes/JourneyForm';

/**
 * @description Renders the work journey create form after a shift type is selected
 */
const JourneyFormSelector = () => {
  const { workJourneyType } = useWorkJourneyContext();

  if (!workJourneyType) {
    return null;
  }

  return <JourneyForm />;
};

export default JourneyFormSelector;
